import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
import {
  SIGNEDUP_SUCCESS,
  USE_TREK_AS_TEMPLATE_SUCCESS,
  TREK_PAYMENT_SUCCESS,
  LODGE_BOOKING_REQUEST_SUCCESS,
  SET_USER_ID,
  FLIGHT_BOOKING_SUCCESS,
  TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW,
  ON_EMAIL_SUBSCRIPTION,
  ON_FLIGHTS_SEARCH,
  ON_FLIGHTS_BOOK_BUTTON_PRESS,
  ON_FLIGHTS_REVIEW_VIEW,
  ACTIVATE_OPTIMIZE,
  ON_CART_PAYMENT_SUCCESS,
  ON_HG_CREDIT_USED,
  ON_TRANSPORTATION_PAYMENT_SUCCESS,
  ON_TRANSPORTATION_CREDIT_USED,
} from '../actions/types';

const eventForTrekPaymentReviewView = action => {
  return {
    event: 'viewTrekPaymentReview',
    selectedTrekName: action.trekName,
  };
};

const eventForNewTrekCreated = () => {
  return {
    event: 'trekCreationSuccess',
  };
};

const eventForNewSignup = () => {
  return {
    event: 'signupSuccess',
    formId: 'signup-form',
  };
};

const eventForTrekPaymentSuccess = action => {
  return {
    event: 'trekPaymentSuccess',
    trekPurchasedRevenue: action.amount,
    paymentType: action.paymentType,
  };
};

const eventForLodgeBookingRequestSuccess = action => {
  return {
    event: 'lodgeBookingRequestSuccess',
    lodgeBookingRequestRevenue: action.amount,
    lodgeName: action.lodgeName,
  };
};

const eventForSetUserId = action => {
  return {
    event: 'setUserId',
    userId: action.userId,
  };
};

const eventForFlightBookingSuccess = action => {
  return {
    event: 'flightBookingSuccess',
    flightBookingRevenue: action.amount,
    flightBookingType: action.flightType,
  };
};

const eventForEmailSubscription = () => ({
  event: 'emailSubscription',
  label: 'Subscription From Flights',
});

const eventForFlightSearch = action => ({
  event: 'flightSearched',
  flight_startdate: action.startDate,
});

const eventForFlightBookButtonPress = () => ({
  event: 'flightBookButtonPressed',
});

const eventForFlightReviewView = () => ({
  event: 'flightsDetailsReviewView',
});

const eventForActivatingOptimize = () => ({
  event: 'optimize.activate',
});

const eventForCartPaymentSuccess = action => ({
  event: 'cartPaymentSuccess',
  cartPaymentAmount: action.amount,
});

const eventForHGCreditUsed = () => ({
  event: 'HGcreditUsed',
});

const eventForTransportationPaymentSuccess = ({ amount }) => ({
  event: 'transportaionPaymentSuccess',
  transportationRevenue: amount,
});

const eventForTransporationCreditUsed = () => ({
  event: 'transportationCreditUsed',
});

const eventsMapper = action => {
  switch (action.type) {
    case SIGNEDUP_SUCCESS:
      return eventForNewSignup;
    case USE_TREK_AS_TEMPLATE_SUCCESS:
      return eventForNewTrekCreated;
    case TREK_PAYMENT_SUCCESS:
      return eventForTrekPaymentSuccess;
    case LODGE_BOOKING_REQUEST_SUCCESS:
      return eventForLodgeBookingRequestSuccess;
    case SET_USER_ID:
      return eventForSetUserId;
    case FLIGHT_BOOKING_SUCCESS:
      return eventForFlightBookingSuccess;
    case TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW:
      return eventForTrekPaymentReviewView;
    case ON_EMAIL_SUBSCRIPTION:
      return eventForEmailSubscription;
    case ON_FLIGHTS_SEARCH:
      return eventForFlightSearch;
    case ON_FLIGHTS_BOOK_BUTTON_PRESS:
      return eventForFlightBookButtonPress;
    case ON_FLIGHTS_REVIEW_VIEW:
      return eventForFlightReviewView;
    case ACTIVATE_OPTIMIZE:
      return eventForActivatingOptimize;
    case ON_CART_PAYMENT_SUCCESS:
      return eventForCartPaymentSuccess;
    case ON_HG_CREDIT_USED:
      return eventForHGCreditUsed;
    case ON_TRANSPORTATION_PAYMENT_SUCCESS:
      return eventForTransportationPaymentSuccess;
    case ON_TRANSPORTATION_CREDIT_USED:
      return eventForTransporationCreditUsed;
    default:
      return [];
  }
};

const gtm = GoogleTagManager();

export default createMiddleware(eventsMapper, gtm);



// WEBPACK FOOTER //
// ./src/redux/middlewares/reduxBeacon.js